import styled from "styled-components";
import { VFlex } from "../styled/Flex";

export const SDialogContainer = styled(VFlex)`
  background: #314d62;
  border-radius: 16px;
  border: 1px solid #376f9e;
  height: 90vh;
  max-height: 578px;
  align-items: center;
  overflowy: scroll;
`;
